module.exports = __webpack_public_path__ + "static/image501-638610dc0796471f58c647c1652b18bc.png";